<!--
  Demonstrates how to reuse content within JSS using name of placeholder. Reference shared content using its ID
  is defined in /data/component-content/EditorialContent/en.json and used in /data/routes/main/en.json)

  See https://github.com/Sitecore/jss/blob/dev/samples/vue/src/components/Styleguide/Styleguide-Layout-Reuse.vue
  for the reused content definition sample.

  We can reuse this content definition in multiple places because it:
   has an ID
   is under component-content (normally) or content
   Reuse is accomplished by referencing the content by ID in a route definition.
   See sample at https://github.com/Sitecore/jss/blob/dev/samples/vue/data/component-content/Styleguide/ContentReuse/LoremIpsumContentBlock/en.yml
-->

<template>
  <sc-placeholder :rendering="rendering" name="digital-house-editorial-component" class="details-container">
  </sc-placeholder>
</template>

<script>
  import { Image, Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue'

  export default {
    metaInfo () {
      return {
        bodyAttrs: {
          class: 'note'
        }
      }
    },
    name: 'EditorialComponent',
    props: {
      fields: {
        type: Object
      },
      rendering: {
        type: Object
      }
    },
    components: {
      ScImage: Image,
      ScText: Text,
      scPlaceholder: Placeholder
    }
  }
</script>
<style lang="scss" scoped>

  .details-container {
    padding: $d-med;
    text-align: center;
    margin: auto;
    @include breakpoint(medium) {
      padding: $d-x-large $d-large;
      width: 80%;
    }
  }
</style>
